import React from "react"
import { Link } from "gatsby"
import { Container, Row, Col, Accordion, Card } from "react-bootstrap"


const FAQ = () => (
  <div id="faq" className="faq">
    <Container className="faq-container">
      <Col md="12" lg="12">
        <div className="faq-info">
          <h2>Frequently Asked Questions</h2>
          <p>If you have more questions, check out the <Link to="/docs">documentation</Link> or email us <a href="mailto:team@scrapeowl.com">team@scrapeowl.com</a>, we would love to hear from you!</p>
        </div>

        <Accordion>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              What is ScrapeOwl?
          </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>ScrapeOwl is a web scraping API that unlike other scraping APIs, only gets you the elements that you specify.</Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="1">
              Can I Scrape all Elements?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <Card.Body>Of course you can! Simply leave the element field empty when submitting a request and ScrapeOwl will return the full page.</Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="2">
              How is ScrapeOwl different?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="2">
              <Card.Body>All Scrapers scrape — what we do is develop the best tooling for you to get what you actually need and not just scrape.</Card.Body>
            </Accordion.Collapse>
          </Card>
          {/* <Card>
            <Accordion.Toggle as={Card.Header} eventKey="3">
              Do you guarantee uptime?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="3">
              <Card.Body>Yes, as part of our business plan (which costs $199/mo) we guarantee 99.999% uptime to ensure your services remain fresh and uninterrupted.</Card.Body>
            </Accordion.Collapse>
          </Card> */}
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="4">
              Do you have a free plan?
          </Accordion.Toggle>
            <Accordion.Collapse eventKey="4">
              <Card.Body>Not at this time. We offer high quality reliable scraping and parsing services that are intended for startups or businesses to use. However, if you are an underrepresented or underprivileged person, please contact <a href="mailto:team@scrapeowl.com">team@scrapeowl.com</a> and we would be happy to see how we can help you succeed.</Card.Body>
            </Accordion.Collapse>
          </Card>
          {/*<Card>
            <Accordion.Toggle as={Card.Header} eventKey="5">
              Can I get a free trial?
          </Accordion.Toggle>
            <Accordion.Collapse eventKey="5">
              <Card.Body>Absolutely. All customers get a limited (up to 1000 credits) 7 day free trial once you've signed up with your credit card. If you go above the 1,000 credit limit, you will be notified and automatically charged $99 as long as you stay under the 1M credit limit laid out in the <Link to="/pricing">Startups Plan</Link>.</Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="6">
              How about refunds?
          </Accordion.Toggle>
            <Accordion.Collapse eventKey="6">
              <Card.Body>If you are on a monthly plan, we offer a 3 day refund period where you can cancel the service and get your money back with no questions asked provided you do not exceed 10,000 credits used. We also refund annual plans starting from the month unused. For example, if you signed up for an annual plan in June and request a refund before it is July, the monthly cost for June is deducted per the monthly subscription calculation and you are refunded the remaining amount.</Card.Body>
            </Accordion.Collapse>
          </Card>
           <Card>
            <Accordion.Toggle as={Card.Header} eventKey="7">
              How can I see remaining credits?
          </Accordion.Toggle>
            <Accordion.Collapse eventKey="7">
              <Card.Body>Simply log on to the <a href="https://app.scrapeowl.com">dashboard</a> using your credentials and you will see how many credits you have consumed and how many you have left.</Card.Body>
            </Accordion.Collapse>
          </Card> */}
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="8">
              Need more credits or help scraping?
          </Accordion.Toggle>
            <Accordion.Collapse eventKey="8">
              <Card.Body>Reach out to us at <a href="mailto:team@scrapeowl.com">team@scrapeowl.com</a> and we will help you figure out a plan and a way to accomplish your goals. We built this product to serve you and solve your problems in any way we can.</Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </Col>
    </Container>
  </div>
)

export default FAQ
